import { render, staticRenderFns } from "./TcpaDisclosure.vue?vue&type=template&id=41c0b5c3&"
import script from "./TcpaDisclosure.vue?vue&type=script&lang=js&"
export * from "./TcpaDisclosure.vue?vue&type=script&lang=js&"
import style0 from "./TcpaDisclosure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports